export default [
  {
    title: '开关',
    key: 'switch',
    width: 16
  },
  {
    title: '账号ID',
    key: 'id',
    width: 48
  },
  {
    title: '账号名称',
    key: 'adAccount',
    width: 48,
    overflow: true
  },
  {
    title: '账号简称',
    key: 'adAccountSimpleName',
    width: 48,
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 48
  },
  {
    title: '计划主ID',
    key: 'advertiserId',
    width: 48,
    overflow: true
  },
  {
    title: '账号类型',
    key: 'accountType',
    width: 48
  },
  {
    title: '绑定管家户',
    key: 'manageAccount',
    width: 48,
    overflow: true
  },
  {
    title: '管理人员',
    key: 'optNames',
    width: 48,
    overflow: true
  },
  {
    title: '投放返点',
    key: 'rebate',
    width: 48
  },
  {
    title: '账号状态',
    key: 'status',
    width: 48
  },
  {
    title: '结算方式',
    key: 'settleType',
    width: 48
  },
  {
    title: '开票单位',
    key: 'invoiceUnit',
    width: 48,
    overflow: true
  },
  {
    title: '开户主体',
    key: 'companyName',
    width: 48,
    overflow: true
  },
  {
    title: '修改人',
    key: 'createOpName',
    width: 48
  },
  {
    title: '新建时间',
    key: 'createTime',
    width: 48,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: 48
  }
]
